import { deserialize } from 'class-transformer';
import { $ } from '../simpli';
var SocketConnection = /** @class */ (function () {
    function SocketConnection(cls, endpoint) {
        this.cls = cls;
        this.socket = new WebSocket("" + $.socketURL + encodeURI(endpoint));
    }
    SocketConnection.prototype.disconnect = function () {
        this.socket.close();
    };
    SocketConnection.prototype.onOpen = function (callback) {
        this.socket.onopen = function (e) {
            callback(e);
        };
    };
    SocketConnection.prototype.onClose = function (callback) {
        this.socket.onclose = function (e) {
            callback(e);
        };
    };
    SocketConnection.prototype.onError = function (callback) {
        this.socket.onerror = function (e) {
            callback(e);
        };
    };
    SocketConnection.prototype.onData = function (callback) {
        var self = this;
        this.socket.onmessage = function (e) {
            if (self.cls.name === 'String') {
                callback(e.data);
                return;
            }
            var data = e.data;
            var resp = deserialize(self.cls, data);
            callback(resp);
        };
    };
    SocketConnection.prototype.onOpenPromise = function () {
        var _this = this;
        var promiseFunc = function (resolve) {
            _this.onOpen(function (e) { return resolve(e); });
        };
        return new Promise(promiseFunc);
    };
    SocketConnection.prototype.onClosePromise = function () {
        var _this = this;
        var promiseFunc = function (resolve) {
            _this.onClose(function (e) { return resolve(e); });
        };
        return new Promise(promiseFunc);
    };
    SocketConnection.prototype.onErrorPromise = function () {
        var _this = this;
        var promiseFunc = function (resolve) {
            _this.onError(function (e) { return resolve(e); });
        };
        return new Promise(promiseFunc);
    };
    SocketConnection.prototype.onDataPromise = function () {
        var _this = this;
        var promiseFunc = function (resolve) {
            _this.onData(function (resp) { return resolve(resp); });
        };
        return new Promise(promiseFunc);
    };
    return SocketConnection;
}());
export { SocketConnection };
//# sourceMappingURL=SocketConnection.js.map